import { jsx as c } from "react/jsx-runtime";
import { u as d } from "./index-6a632112.mjs";
import { i as a, j as r, s as t, a as s, r as m, e as l } from "./themes-5f0b3c3d.mjs";
import { l as u } from "./lineHeights-72d3110c.mjs";
import "react";
function o(e, i) {
  switch (!0) {
    case (e === "large" && i !== void 0):
      return t["6x"];
    case (e === "medium" && i !== void 0):
      return t["5x"];
    case (e === "small" && i !== void 0):
      return t["4x"];
    case (e === "large" && i === void 0):
      return t["4x"];
    case (e === "medium" && i === void 0):
      return t["3x"];
    case (e === "small" && i === void 0):
      return t["2x"];
    default:
      return t["5x"];
  }
}
const h = d.div`
  --badge-text-color: ${(e) => {
  if (e.$emphasis === "high" || e.$emphasis === void 0)
    return a.onColor;
  if (e.$emphasis === "low")
    switch (e.type) {
      case "primary":
        return a["primary-strong"];
      case "neutral":
        return a.subtle;
      case "danger":
        return a.danger;
      case "success":
        return a.success;
      case "warning":
        return a.caution;
      default:
        return a["primary-strong"];
    }
}};

  --badge-height: ${(e) => e?.size && o(e.size, e.value)};

  --badge-min-width: ${(e) => e?.size && o(e.size, e.value)};

  --badge-background-color: ${(e) => {
  if (e.$emphasis === "high" || e.$emphasis === void 0)
    switch (e.type) {
      case "primary":
        return r["primary-strong"];
      case "neutral":
        return r["neutral-strong"];
      case "danger":
        return r["danger-strong"];
      case "success":
        return a["success-strongest"];
      case "warning":
        return r["caution-strong"];
      default:
        return r["primary-strong"];
    }
  else if (e.$emphasis === "low")
    switch (e.type) {
      case "primary":
        return r["primary-subtlest"];
      case "neutral":
        return r["neutral-subtle"];
      case "danger":
        return r["danger-subtlest"];
      case "success":
        return r["success-subtlest"];
      case "warning":
        return r["caution-subtlest"];
      default:
        return r["primary-subtlest"];
    }
}};
  --line-height: ${(e) => e.size === "small" ? u.xsmall : e.size === "medium" ? u.small : u.medium};

  --value-width: ${(e) => e.size === "small" ? "6px" : t["2x"]};

  --font-size: ${(e) => e.size === "small" ? s.xxsmall : e.size === "medium" ? s.xsmall : s.small};
  padding: ${(e) => e?.value?.toString().length === 1 || e?.value ? `0px ${t["1x"]}` : "unset"};

  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: var(--badge-height);
  width: fit-content;
  min-width: var(--badge-min-width);
  border-radius: ${m["3x"]};
  text-align: center;
  background-color: var(--badge-background-color);
  font-weight: ${(e) => e.size === "large" && l.semiBold.M.fontWeight || e.size === "medium" && l.semiBold.S.fontWeight || e.size === "small" && l.semiBold.XS.fontWeight};
  font-family: Inter, sans-serif;
  box-sizing: border-box;
`, f = d.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  line-height: var(--line-height);
  height: var(--line-height);
  font-size: var(--font-size);
  color: var(--badge-text-color);
  text-align: center;
`;
function w({
  size: e = "medium",
  emphasis: i = "high",
  type: g = "primary",
  ...n
}) {
  return /* @__PURE__ */ c(h, { size: e, emphasis: i, type: g, ...n, children: /* @__PURE__ */ c(f, { role: "status", "aria-label": n.ariaLabel, "aria-live": "polite", children: n.value }) });
}
export {
  w as Badge
};
